import React, { useEffect, useState } from "react";

// icons
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";

// components
import DashboardBarChart from "../../../components/alcohol/chart/dashboard/DashboardBarChart";

// api
import {
    getDashboardPatientType,
    getDashboardTraining,
    getDashboardTrainingWeek,
    getDashboardVisitor
} from "../../../services/apis/alcohol/dashboard";
import { postPushMessageToAlcohol } from "../../../services/apis/alcohol/message";


// Date 데이터를 string(YYMMDD, YY.MM.DD) 형식으로 변환
const convertDateToString = (date, strType) => {
    const yearNum = date.getFullYear();
    const monthNum = (date.getMonth()+1).toString().padStart(2, '0');
    const dateNum = date.getDate().toString().padStart(2, '0');

    if(strType==="YYYYMMDD"){
        return `${yearNum}${monthNum}${dateNum}`;
    }else if(strType==="YY.MM.DD"){
        return `${yearNum.toString().slice(2)}.${monthNum}.${dateNum}`;
    }else{ // strType==="YY-MM-DD"
        return `${yearNum}-${monthNum}-${dateNum}`;
    }
}


function AlcoholDashboardPage() {
    // 교육 상태별 건수
    const [trainingInfo, setTrainingInfo] = useState({
        진행중: 0,
        완료: 0,
        조기종료: 0
    })
    // 환자 타입별 건수
    const [patientTypeInfo, setPatientTypeInfo] = useState({
        HN: 0, // 음주 높고 변화준비 안됨
        HR: 0, // 음주 높고 변화준비 됨
        LN: 0, // 음주 낮고 변화준비 안됨
        LR: 0 // 음주 낮고 변화준비 됨
    })
    // 조회 타입별 방문자 건수
    const [visitorInfo, setVisitorInfo] = useState([]);
    // 주차별 환자 건수
    const [trainingWeekInfo, setTrainingWeekInfo] = useState({ 정상: new Array(8).fill(0), 미달: new Array(8).fill(0), 탈락: new Array(8).fill(0) });

    // visitorGroupType : d(일), w(주), m(월)
    const [visitorGroupType, setVisitorGroupType] = useState('m');
    const [visitorDate, setVisitorDate] = useState({
        start: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        end: new Date(new Date().getFullYear(), new Date().getMonth()+1, 0)
    });

    // GET 교육 상태별 건수 조회
    async function getTrainingInfoFromAPI() {
        try{
            const res = await getDashboardTraining();
            if(parseInt(res.status/200,10)===1){
                const newTrainingInfo = {
                    진행중: 0,
                    완료: 0,
                    조기종료: 0
                };
                res.data.forEach((e)=>{
                    newTrainingInfo[e.name] = e.count;
                })
                setTrainingInfo(newTrainingInfo);
            }
        }catch(err){
            console.error(err);
        }
    }

    // GET 환자 타입별 건수 조회
    async function getPatientTypeInfoFromAPI() {
        try{
            const res = await getDashboardPatientType();
            if(parseInt(res.status/200,10)===1){
                const newPatientType = {
                    HN: 0,
                    HR: 0,
                    LN: 0,
                    LR: 0
                };
                res.data.forEach((e)=>{
                    newPatientType[e.code] = e.count;
                })
                setPatientTypeInfo(newPatientType);
            }
        }catch(err){
            console.error(err);
        }
    }

    // GET 조회 타입별 방문자 건수 조회
    async function getVisitorInfoFromAPI(){
        try{
            const request = {
                "group-type" : visitorGroupType==="d" ? "h" : "d",
                "start" : convertDateToString(visitorDate.start, "YYYYMMDD"),
                "end" : convertDateToString(visitorDate.end, "YYYYMMDD")
            }
            const res = await getDashboardVisitor(request);
            if(parseInt(res.status/200,10)===1 && res.data.length){
                const newData = res.data.map(e=>({
                    ...e,
                    name: e.name.slice(-2)
                }));
                setVisitorInfo(newData);
            }else{
                setVisitorInfo([]);
            }
        }catch(err){
            console.error(err);
        }
    }

    // GET 학습 주차별 환자 건수 조회
    async function getTrainingWeekInfoFromAPI() {
        try{
            const res = await getDashboardTrainingWeek();
            
            if(parseInt(res.status/200,10)===1) {
                if(res.data.length>0){
                    const newTrainingWeekInfo = { 정상: new Array(8).fill(0), 미달: new Array(8).fill(0), 탈락: new Array(8).fill(0) };
                    res.data.forEach(e=>{
                        newTrainingWeekInfo[e.name][Number(e.code)-1] = e.count; 
                    })
                    setTrainingWeekInfo(newTrainingWeekInfo);
                }
            }
        }catch(err){
            console.error(err);
        }
    }

    const handleMoveVisitorDate = (moveType) => {
        let targetStart = new Date(visitorDate.start);
        let targetEnd = new Date(visitorDate.end);

        if(moveType==="prev") {
            if(visitorGroupType==="d"){
                targetStart.setDate(visitorDate.start.getDate()-1);
                targetEnd.setDate(visitorDate.end.getDate()-1);
            }else if(visitorGroupType==="w") {
                targetStart.setDate(visitorDate.start.getDate()-7);
                targetEnd.setDate(visitorDate.end.getDate()-7);
            }else{
                targetStart = new Date(targetStart.getFullYear(), targetStart.getMonth()-1, 1);
                targetEnd = new Date(targetEnd.getFullYear(), targetEnd.getMonth(), 0);
            }

            setVisitorDate({start: targetStart, end: targetEnd}); 
        }else {
            if(visitorGroupType==="d"){
                targetStart.setDate(visitorDate.start.getDate()+1);
                targetEnd.setDate(visitorDate.end.getDate()+1);
            }else if(visitorGroupType==="w") {
                targetStart.setDate(visitorDate.start.getDate()+7);
                targetEnd.setDate(visitorDate.end.getDate()+7);
            }else{
                targetStart = new Date(targetStart.getFullYear(), targetStart.getMonth()+1, 1);
                targetEnd = new Date(targetEnd.getFullYear(), targetEnd.getMonth()+2, 0);
            }

            setVisitorDate({start: targetStart, end: targetEnd});
        }
    }

    const handleChangeVisitorGroupType = (selectedGroupType) => {
        if(selectedGroupType==="d"){
            setVisitorGroupType("d");

            setVisitorDate({ start: new Date(), end: new Date() });
        }else if(selectedGroupType==="w") {
            setVisitorGroupType("w");
            const today = new Date().getDay()===0 ? 7 : new Date().getDay();
            const mondayThisWeek = new Date();
            mondayThisWeek.setDate(new Date().getDate() - today + 1);
            const sundayThisWeek = new Date();
            sundayThisWeek.setDate(new Date().getDate() + 7 - today);

            setVisitorDate({ start: mondayThisWeek, end: sundayThisWeek });
        }else {
            setVisitorGroupType("m");

            setVisitorDate({
                start: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                end: new Date(new Date().getFullYear(), new Date().getMonth()+1, 0)
            });
        }
    }

    function getCurrentDateTime() {
        const now = new Date();
        
        // 년, 월, 일, 시, 분을 가져오기
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        
        // YYYYMMDDHH24MI 형식으로 조합하여 반환
        return `${year}${month}${day}${hours}${minutes}`;
    }

    // 진도 미달자 메시지 전송
    const handleSendMessage = async () => {
        try{
            const currentDateStr = getCurrentDateTime();
            const request = {
                target: "T",
                sex: "A",
                training: "40",
                subject: "[알코지니]",
                contents: "알코지니를 깜빡하셨나요?\n건강한 음주습관을 알코지니와 함께 다시 시작해봐요.",
                sendDate: currentDateStr
              }
            const res = await postPushMessageToAlcohol(request);
            
            if(parseInt(res.status/200,10)===1){
                alert('메시지를 전송했습니다.');
            }else{
                alert('메시지 전송에 실패하였습니다.')
            }
        }catch(err){
            console.error(err);
            alert("메시지 전송에 실패하였습니다.");
        }        
    }

    useEffect(()=>{
        getTrainingInfoFromAPI();
        getPatientTypeInfoFromAPI();
        getTrainingWeekInfoFromAPI();
    },[])

    useEffect(()=>{
        getVisitorInfoFromAPI();
    },[visitorGroupType, visitorDate])


    return (
        <div className="dashboardContent">
            <div className="dashboardContent__title">
                <span className="dashboardContent__title__content">
                    Dashboard
                </span>
            </div>
            <div className="Dashboard-Content">
                <div className="Dashboard-Content-Row1">
                    <div className="Content1">
                        <div className="Content1-Box">
                            <div>전체 사용자</div>
                            <div>{trainingInfo.진행중 + trainingInfo.완료 + trainingInfo.조기종료}</div>
                        </div>
                        <div className="Content1-Box">
                            <div>교육 진행중 사용자</div>
                            <div>{trainingInfo.진행중}</div>
                        </div>
                        <div className="Content1-Box">
                            <div>종료된 사용자</div>
                            <div>{trainingInfo.완료}</div>
                        </div>
                        <div className="Content1-Box">
                            <div>조기 종료 사용자</div>
                            <div>{trainingInfo.조기종료}</div>
                        </div>
                    </div>
                    <div className="Content2">
                        <div className="Content2-Title">타입별 환자</div>
                        <div className="Content2-Table">
                            <div className="Content2-Table-Inner">
                                <div className="Content2-Table-Row">
                                    <div>문제성 음주</div>
                                    <div>변화 준비</div>
                                    <div>환자수</div>
                                </div>
                                <div className="Content2-Table-Row">
                                    <div>High</div>
                                    <div>Ready</div>
                                    <div>{patientTypeInfo.HR}명</div>
                                </div>
                                <div className="Content2-Table-Row">
                                    <div>High</div>
                                    <div>No</div>
                                    <div>{patientTypeInfo.HN}명</div>
                                </div>
                                <div className="Content2-Table-Row">
                                    <div>Low</div>
                                    <div>Ready</div>
                                    <div>{patientTypeInfo.LR}명</div>
                                </div>
                                <div className="Content2-Table-Row">
                                    <div>Low</div>
                                    <div>No</div>
                                    <div>{patientTypeInfo.LN}명</div> 
                                </div>
                                <div className="Line" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="Dashboard-Content-Row2">
                    <div className="Content-Header">
                        <div>앱 방문자 수</div>
                        <div>
                            <button type="button" aria-label="Left Arrow Button" onClick={()=>handleMoveVisitorDate('prev')}>
                                <AiOutlineLeft />
                            </button>
                            {visitorGroupType==="d" ? (
                                <div>
                                    {convertDateToString(visitorDate.start,'YY.MM.DD')}
                                </div>
                            ) : (
                                <div>
                                    {convertDateToString(visitorDate.start,'YY.MM.DD')} ~ {convertDateToString(visitorDate.end,'YY.MM.DD')}
                                </div>
                            )}
                            <button type="button" aria-label="Right Arrow Button" onClick={()=>handleMoveVisitorDate('next')}>
                                <AiOutlineRight />
                            </button>
                        </div>
                        <div>
                            <button onClick={()=>handleChangeVisitorGroupType('d')}>일</button>
                            <button onClick={()=>handleChangeVisitorGroupType('w')}>주</button>
                            <button onClick={()=>handleChangeVisitorGroupType('m')}>월</button>
                        </div>
                    </div>
                    <DashboardBarChart visitorData={visitorInfo} />
                </div>
                <div className="Dashboard-Content-Row3">
                    <div className="Content3-Header">
                        <div>주차별 사용자 수</div>
                        <button onClick={handleSendMessage}>진도 미달자 메시지 보내기</button>
                    </div>
                    <div className="Content3-Table">
                        <div className="Week">
                            <div>1</div>
                            <div />
                            <div>2</div>
                            <div />
                            <div>3</div>
                            <div />
                            <div>4</div>
                            <div />
                            <div>5</div>
                            <div />
                            <div>6</div>
                            <div />
                            <div>7</div>
                            <div />
                            <div>8</div>
                        </div>
                        <div className="Content3-Users Content3-Users-First">
                            <div>전체</div>
                            {new Array(8).fill(0).map((_, idx)=>(
                                <div key={idx}>{trainingWeekInfo.정상[idx] + trainingWeekInfo.미달[idx] + trainingWeekInfo.탈락[idx]}</div>
                            ))}
                            </div>
                        <div className="Content3-Users">
                            <div>정상</div>
                            {trainingWeekInfo.정상.map((e, idx)=>(
                                <div key={idx}>{e}</div>
                            ))}
                        </div>
                        <div className="Content3-Users">
                            <div>미달</div>
                            {trainingWeekInfo.미달.map((e, idx)=>(
                                <div key={idx}>{e}</div>
                            ))}
                        </div>
                        <div className="Content3-Users">
                            <div>탈락</div>
                            {trainingWeekInfo.탈락.map((e, idx)=>(
                                <div key={idx}>{e}</div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AlcoholDashboardPage;